import React from 'react';

const HistoryReport = () => {
    return (
        <div>
            Owner Verification
        </div>
    )
};

export default HistoryReport;